import { MOBILEDEVICEWIDTH } from "config/constants";
import { colours } from "styling/colours";
import { media, style, stylesheet } from "typestyle";

export const wrapperStyle = style(
  {
    marginBottom: "10px",
    position: "relative",
    overflow: "auto",
    width: "100%",
    $nest: {
      "::-webkit-scrollbar": {
        width: "7px",
        height: "9px",
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: "rgba(205, 208, 227, 0)",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(188, 190, 192, 0.5)",
        width: "7px",
        height: "9px",
        borderRadius: "14px",
      },
      "::-webkit-scrollbar-track:horizontal": {
        border: "1px solid rgba(205, 208, 227, 0.5)",
        borderRadius: "6px",
      },
    },
  },
  media({ maxWidth: MOBILEDEVICEWIDTH }, { display: "none" })
);

export const TableStyle = stylesheet({
  container: {
    overflow: "auto",
    paddingBottom: "2em",
    marginTop: "1em",
    width: "100%",
    height: "100%",
    transition: "0.1s ease-in-out",
    "-webkit-transform": 'translateZ(0)',
  },
  table: {
    borderCollapse: "separate",
    borderSpacing: "0 10px",
    textAlign: "left",
    width: 'fit-content',
    minWidth: '100%',

    $nest: {
      "& thead": {
        textTransform: "uppercase",
        color: colours.primary,
        fontFamily: "MuseoSlab",
        fontSize: "12px",
        letterSpacing: "1px",
        height: "40px",
        position: 'relative',
        top: '-10px',
      },
      "& th": {
        padding: "0 12px",
        fontWeight: "normal",
        background: colours.background,
        position: "sticky",
        top: 0,
        zIndex: 2,
        $nest: {
          "&:first-child": {
            paddingLeft: "24px",
          },
          "&:last-child": {
            paddingRight: "24px",
          },
        },
      },
      "& tbody": {
        position: 'relative',
        top: '-15px',
      },
      "& tr": {
        background: colours.background,
        borderRadius: "6px",
        height: "68px",
        padding: "0 24px",
      },
      "& td": {
        background: colours.white,
        borderBottom: "1px solid rgba(205, 208, 227, 0.5)",
        borderTop: "1px solid rgba(205, 208, 227, 0.5)",
        borderLeft: "none",
        borderRight: "none",
        padding: "10px 12px",
        height: "78px",
        $nest: {
          "&:first-child": {
            paddingLeft: "24px",
            borderLeft: "1px solid rgba(205, 208, 227, 0.5)",
            borderTopLeftRadius: "10px",
            borderBottomLeftRadius: "10px",
            background: colours.white,
          },
          "&:last-child": {
            paddingRight: "24px",
            borderRight: "1px solid rgba(205, 208, 227, 0.5)",
            borderBottomRightRadius: "10px",
            borderTopRightRadius: "10px",
          },
        },
      }
    }
  },
  tBody: {
    fontSize: "15px",
    color: colours.primaryText,
  },

})

export const clickableStyle = style({
  cursor: "pointer"
})